import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { LogoMarquee } from "@/components/site/LogoMarquee";
import { Services } from "@/components/site/Services";
import { Machinery } from "@/components/site/Machinery";
import { Gallery } from "@/components/site/Gallery";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Trust } from "@/components/site/Trust";
import { Footer } from "@/components/site/Footer";
import { WhatsappFloat } from "@/components/site/WhatsappFloat";

export default function Landing() {
  useLenis();
  return (
    <>
      <Header />
      <main>
        <Hero />
        <LogoMarquee />
        <Services />
        <Machinery />
        <Gallery />
        <QuoteForm />
        <Trust />
      </main>
      <Footer />
      <WhatsappFloat />
    </>
  );
}
